import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth, useUser } from "@clerk/clerk-react";
import { BACKEND_URL } from "@/constants/api";

// eslint-disable-next-line react-refresh/only-export-components
export const SchoolContext = createContext(null);

export function SchoolProvider({ children }) {
  const [memberships, setMemberships] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { getToken } = useAuth();
  const { isSignedIn, isLoaded } = useUser();

  const refetch = useCallback(async () => {
    try {
      setLoading(true);
      const token = await getToken();
      const res = await fetch(`${BACKEND_URL}api/schools`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Failed to fetch schools");
      setMemberships(await res.json());
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [getToken]);

  useEffect(() => {
    if (isSignedIn && isLoaded) refetch();
    else if (isLoaded && !isSignedIn) setLoading(false);
  }, [isSignedIn, isLoaded, refetch]);

  const isAdmin = memberships.some(m => m.isAdmin);

  return (
    <SchoolContext.Provider value={{ memberships, isAdmin, loading, error, refetch }}>
      {children}
    </SchoolContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components
export function useSchool() {
  const ctx = useContext(SchoolContext);
  if (!ctx) throw new Error("useSchool must be used inside SchoolProvider");
  return ctx;
}
